import { container } from "tsyringe";
export class UseCaseGetLocationsByNameClassic {
    async handle(name) {
        const getLocationsByNameClassic = container.resolve("iGetLocationsByNameClassic");
        const locations = await getLocationsByNameClassic.getLocationsByName(name);
        return locations;
    }
}
export default UseCaseGetLocationsByNameClassic;
